<template>
  <section class="policyContents">
    <div class="container">
      <ul class="tabMenu">
        <li
          v-for="(tab, index) in tabMenuList"
          :key="index"
          :class="{ active: index === tabNumber}"
          @click.stop="onClickTab(index)"
        >
          {{ tab }}
        </li>
      </ul>
      <LazyPolicyContentTerm v-if="tabNumber === 0" />
      <LazyPolicyContentLegal v-else-if="tabNumber === 1" />
      <LazyPolicyContentPrivacy v-else-if="tabNumber === 2" />
      <LazyPolicyContentCookie v-else-if="tabNumber === 3" />
    </div>
  </section>
</template>

<script setup lang="ts">

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const tabNumber = ref(0);
const tabMenuList = [t('common-terms-of-use'),t('common-legal-notice'),t('common-privacy-policy'),t('common-cookie-policy')];

const onClickTab = (tabNum: number) => {
  router.push({ path: "/policy", query: { tab: tabNum }})
}

watch(() => route.query, () => {
  tabNumber.value = parseInt(route.query.tab as string)
}, { immediate: true })
</script>